import React from 'react';
import { NavLink } from 'react-router-dom';
import { Map, BookOpen, ThumbsUp, User } from 'lucide-react';
export function BottomNav() {
  const navItems = [{
    path: '/',
    icon: Map,
    label: 'Map'
  }, {
    path: '/rules',
    icon: BookOpen,
    label: 'Rules'
  }, {
    path: '/recommendations',
    icon: ThumbsUp,
    label: 'Tips'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-surface/80 backdrop-blur-lg border-t border-border pb-safe z-50 md:hidden" data-id="element-68">
      <div className="flex justify-around items-center h-16 px-2" data-id="element-69">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors ${isActive ? 'text-primary' : 'text-text-muted hover:text-text'}`} data-id="element-70">
            {({
          isActive
        }) => <>
                <item.icon size={24} strokeWidth={isActive ? 2.5 : 2} className="transition-transform duration-200" data-id="element-71" />
                <span className="text-[10px] font-medium" data-id="element-72">{item.label}</span>
              </>}
          </NavLink>)}
      </div>
    </nav>;
}